import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // ✅ 添加useLocation
import util from '@utils/utils';

export const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation(); // ✅ 获取当前位置
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const clientId = util.getCurrentClientId();

    // a环境：检查是否有 loginUserName
    if (clientId === 'client-a') {
      const userInfo = util.ensureUserInfo(); // ✅ 确保用户信息并获取返回值

      if (!userInfo) {
        // ensureUserInfo 返回 null 说明未登录，已经触发了跳转
        // 不需要额外操作，保持 loading 状态即可
        return;
      }

      // 有用户信息，设置为已认证
      setIsAuthenticated(true);
      setIsLoading(false);
      return;
    }

    const checkAuth = () => {
      try {
        const userInfo = util.getStorage(process.env.REACT_APP_LOCALSTORAGE_NAME);
        console.log('ProtectedRoute检查用户信息:', userInfo);
        
        // 检查用户信息是否存在且有ID
        if (userInfo && (userInfo.id || userInfo.userId || userInfo.phoneNumber)) {
          const userId = userInfo.id || userInfo.userId || userInfo.phoneNumber;
          console.log('用户认证成功，ID:', userId);
          setIsAuthenticated(true);
        } else {
          console.log('用户认证失败，重定向到登录页');
          
          // ✅ 保存当前URL作为returnUrl
          const currentPath = location.pathname + location.search;
          const returnUrl = encodeURIComponent(currentPath);
          navigate(`/login?returnUrl=${returnUrl}`, { replace: true });
        }
      } catch (error) {
        console.error('Auth check error:', error);
        
        // ✅ 错误时也保存returnUrl
        const currentPath = location.pathname + location.search;
        const returnUrl = encodeURIComponent(currentPath);
        navigate(`/login?returnUrl=${returnUrl}`, { replace: true });
      } finally {
        setIsLoading(false);
      }
    };
    
    checkAuth();
  }, [location.pathname, location.search]); // ✅ 添加location依赖

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="loading loading-spinner loading-lg"></span>
      </div>
    );
  }
  
  return isAuthenticated ? children : null;
};